export default function getSubscriptionIntervalWithSlash(interval, intervalCount) {
  const separator = '/';
  let intervalText = interval;

  // add 's' to pluralize if intervalText hasn't been edited
  if (intervalText === interval && intervalCount && intervalCount > 1) {
    intervalText = `${intervalText}s`;
  }

  // combine interval text with intervalCountText (or 'Every')
  if (intervalCount && intervalCount > 1) {
    intervalText = [separator, 'every', intervalCount, intervalText].join(' ');
  }

  if (intervalCount === 1) {
    intervalText = [separator, intervalText].join(' ');
  }

  return intervalText;
}
